import type { Json } from '@/types/database.generated';

/** Reads logo URL from clinics.branding JSON (not a top-level column). */
export function logoUrlFromBranding(branding: Json | null | undefined): string | null {
  if (branding && typeof branding === 'object' && !Array.isArray(branding)) {
    const url = (branding as Record<string, unknown>).logo_url;
    return typeof url === 'string' && url.length > 0 ? url : null;
  }
  return null;
}
